import { LoanSimulation } from '@src/shared/models';
import { useAppStore } from '@src/shared/zustand/store';

export const updateLoanSimulation = (financing: LoanSimulation) =>
  useAppStore.setState((state) => ({
    loanSimulation: { ...state.loanSimulation, ...financing },
  }));

export const setLoanSimulation = (loanSimulation: LoanSimulation) =>
  useAppStore.setState({ loanSimulation });
